var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"db-document-frame",attrs:{"src":(_vm.publicPath + "dongbb_1.0.0.html")}})}
var staticRenderFns = []

export { render, staticRenderFns }